import { Alert, Card } from "@mui/material";

const PrivilegedInformationHeader: React.FC = () => {
  return (
    <Card elevation={3}>
      <Alert severity="warning">
        Privileged and confidential. For internal use only. Do not share externally.
      </Alert>
    </Card>
  );
}

export default PrivilegedInformationHeader;
